import React from 'react';
import { Flame, Heart, Users, Award } from 'lucide-react';
import { features, heroImages } from '../data/mock';

const About = () => {
  const featureIcons = {
    1: <Heart className="w-8 h-8" />,
    2: <Flame className="w-8 h-8" />,
    3: <Award className="w-8 h-8" />,
    4: <Users className="w-8 h-8" />
  };

  return (
    <section id="about" className="py-24 bg-stone-900 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 opacity-10">
        <img
          src={heroImages.embers}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 text-amber-500 mb-6">
              <Flame className="w-5 h-5" />
              <span className="text-sm uppercase tracking-wider">Hikayemiz</span>
            </div>

            <h2 className="font-serif text-4xl md:text-5xl font-bold text-amber-50 mb-6 leading-tight">
              Balıkesir'in Kalbinden,
              <br />
              <span className="text-amber-500">Sofranıza Gelen Lezzet</span>
            </h2>

            <div className="space-y-6 text-amber-200/70 leading-relaxed">
              <p>
                1985 yılında Sadullah Usta tarafından küçük bir mangal başında başlayan 
                yolculuğumuz, bugün Balıkesir'in en sevilen köftecisi olarak devam ediyor.
              </p>
              <p>
                Kuşaklar boyu aktarılan tariflerimiz, her gün taze ve özenle seçilen 
                etlerimiz ve meşe kömüründe uzun saatler boyunca közlenen köftelerimiz 
                ile damak tadınıza hitap ediyoruz.
              </p>
              <p>
                Balıkesir köftesinin eşsiz lezzetini, geleneksel Türk misafirperverliği 
                ile harmanlıyoruz. Her lokmada, ateşin sıcaklığını ve ustalığın izini 
                hissedeceksiniz.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 mt-10 pt-10 border-t border-amber-900/30">
              <div>
                <div className="font-serif text-4xl text-amber-500 font-bold">40+</div>
                <div className="text-amber-200/50 text-sm mt-1">Yıllık Deneyim</div>
              </div>
              <div>
                <div className="font-serif text-4xl text-amber-500 font-bold">2</div>
                <div className="text-amber-200/50 text-sm mt-1">Şube</div>
              </div>
              <div>
                <div className="font-serif text-4xl text-amber-500 font-bold">1000+</div>
                <div className="text-amber-200/50 text-sm mt-1">Mutlu Müşteri</div>
              </div>
            </div>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <div
                key={feature.id}
                className={`group p-6 bg-stone-950/50 rounded-2xl border border-amber-900/20 hover:border-amber-600/40 transition-all duration-500 hover:shadow-xl hover:shadow-amber-900/10 ${
                  index === 0 ? 'lg:translate-y-8' : ''
                } ${
                  index === 3 ? 'lg:translate-y-8' : ''
                }`}
              >
                <div className="w-16 h-16 bg-amber-600/10 rounded-xl flex items-center justify-center text-amber-500 mb-4 group-hover:bg-amber-600/20 transition-colors">
                  {featureIcons[feature.id]}
                </div>
                <h3 className="font-serif text-xl text-amber-50 mb-2">
                  {feature.title}
                </h3>
                <p className="text-amber-200/50 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;